<template>
  <div class="property-index-container">
    <div class="vc-index-nav">
      <span><i class="el-icon-s-home margin-right-sm"></i>{{ $t('propertyIndex.home') }}</span>
      <span class="margin-left-sm margin-right-sm">/</span>
      <span>{{ $t('propertyIndex.dashboard') }}</span>
    </div>

    <el-row class="vc-index-1" :gutter="20">
      <el-col :span="15">
        <index-community ref="indexCommunity" />
      </el-col>
      <el-col :span="9">
        <index-notice ref="indexNotice" />
      </el-col>
    </el-row>

    <el-row class="vc-index-1" :gutter="20">
      <el-col :span="24">
        <div class="system-reminder-card">
          <div class="index-title text-left"><span>系统提醒</span></div>
          <div class="system-reminder-list">
            <div v-for="item in systemReminders" :key="item.title" class="system-reminder-item" @click="toReminderPage(item.path)">
              <div :class="['system-reminder-icon', item.type]">
                <i :class="item.icon"></i>
              </div>
              <div class="system-reminder-content">
                <div class="system-reminder-title">{{ item.title }}</div>
                <div class="system-reminder-desc">{{ item.desc }}</div>
              </div>
              <div class="system-reminder-count">{{ item.count }}</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row class="vc-index-1" :gutter="20">
      <el-col :span="15">
        <index-repair-complaint ref="indexRepairComplaint" />
      </el-col>
      <el-col :span="9">
        <index-owner-room ref="indexOwnerRoom" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IndexCommunity from '@/components/index/indexCommunity'
import IndexNotice from '@/components/index/indexNotice'
import IndexRepairComplaint from '@/components/index/indexRepairComplaint'
import IndexOwnerRoom from '@/components/index/indexOwnerRoom'
import { queryReportOweFee } from '@/api/fee/listOweFeeApi'
import { queryContract } from '@/api/contract/contractManageApi'

export default {
  name: 'PropertyIndexList',
  components: {
    IndexCommunity,
    IndexNotice,
    IndexRepairComplaint,
    IndexOwnerRoom
  },
  data() {
    return {
      systemReminders: [
        {
          title: '到期 / 欠费提醒',
          desc: '物业费到期、欠费自动提醒',
          count: '加载中',
          icon: 'el-icon-warning-outline',
          type: 'fee',
          path: '/pages/property/listOweFee'
        },
        {
          title: '合同提醒',
          desc: '各类合同临期自动提醒',
          count: '加载中',
          icon: 'el-icon-document',
          type: 'contract',
          path: '/pages/admin/contractManage'
        }
      ]
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.$refs.indexCommunity._loadPropertyIndexAssets()
      this.$refs.indexNotice._loadPropertyIndexNotices()
      this.$refs.indexRepairComplaint.initData()
      this.$refs.indexOwnerRoom._loadIndexOwnerRegisterData()
      this.loadReminderData()
    },
    async loadReminderData() {
      await Promise.all([
        this.loadOweFeeReminder(),
        this.loadContractReminder()
      ])
    },
    async loadOweFeeReminder() {
      try {
        const { total } = await queryReportOweFee({
          page: 1,
          row: 1,
          billType: '00123'
        })
        this.setReminderCount('fee', total || 0)
      } catch (error) {
        console.error('获取欠费提醒失败:', error)
        this.setReminderCount('fee', 0)
      }
    },
    async loadContractReminder() {
      try {
        const { total } = await queryContract({
          page: 1,
          row: 1,
          endTime: this.getContractReminderEndTime()
        })
        this.setReminderCount('contract', total || 0)
      } catch (error) {
        console.error('获取合同提醒失败:', error)
        this.setReminderCount('contract', 0)
      }
    },
    setReminderCount(type, count) {
      const reminder = this.systemReminders.find(item => item.type === type)
      if (reminder) {
        reminder.count = `待处理 ${count} 条`
      }
    },
    getContractReminderEndTime() {
      const date = new Date()
      date.setDate(date.getDate() + 30)
      const pad = value => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} 23:59:59`
    },
    toReminderPage(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.property-index-container {

  padding: 0 10px; // 添加左右内边距

  .vc-index-nav {
    padding: 10px;
    font-size: 16px;
    text-align: left;
  }

  .margin-right-sm {
    margin-right: 5px;
  }

  .margin-left-sm {
    margin-left: 5px;
  }

  .margin-top-lg {
    margin-top: 15px;
  }

  .margin-bottom {
    margin-bottom: 20px;
  }

  .vc-index-1 {
    margin-bottom: 20px;

    .index-1-left,
    .index-1-right {
      height: 100%;
    }
  }

  .system-reminder-card {
    background: #fff;
    border-radius: 4px;
    padding: 15px;

    .index-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #333;
    }
  }

  .system-reminder-list {
    display: flex;
    gap: 20px;
  }

  .system-reminder-item {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 18px 20px;
    border: 1px solid #eef1f6;
    border-radius: 6px;
    background: #fafcff;
    cursor: pointer;

    &:hover {
      border-color: #409eff;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.12);
    }
  }

  .system-reminder-icon {
    width: 46px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    border-radius: 50%;

    i {
      font-size: 24px;
    }

    &.fee {
      background: #fff7e6;
      color: #e6a23c;
    }

    &.contract {
      background: #ecf5ff;
      color: #409eff;
    }
  }

  .system-reminder-content {
    flex: 1;
    text-align: left;
  }

  .system-reminder-title {
    margin-bottom: 6px;
    color: #333;
    font-size: 15px;
    font-weight: bold;
  }

  .system-reminder-desc {
    color: #999;
    font-size: 13px;
  }

  .system-reminder-count {
    color: #f56c6c;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>